module.exports = __webpack_public_path__ + "static/img/076_TO8_1708.bf3a24f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/076_TO8_1708.jpg
// module id = Sl/j
// module chunks = 0